import { Component } from '@angular/core';

@Component({
  selector: 'lx-quote-course-details-name',
  templateUrl: './quote-course-details-name.component.html',
  styleUrls: ['./quote-course-details-name.component.scss'],
})
export class QuoteCourseDetailsNameComponent {}
